// extracted by mini-css-extract-plugin
module.exports = {"text":"text--3tplk","hidden":"hidden--26C2e","counter":"counter--2h2Aj"};